import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Fade from "@mui/material/Fade";
import { Box, Typography, styled } from "@mui/material";
import Button from "../../components/Button";
import CustomTextField from "../../components/Textfield";
import { getSx } from "../../components/Modal/style";
import { useDispatch } from "react-redux";
import { showToast } from "../../store/slices/common";
import { createCategory, updateCategory } from "../../http/auth";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Fade ref={ref} {...props} />;
});

const CustomDialog = styled(Dialog)(() => ({
    "& .MuiDialog-paper": {
        width: "400px",
        padding: "30px",
        borderRadius: "20px",
    },
    "& .MuiPaper-root": { maxWidth: "400px" },
    "& .MuiDialogActions-root": {},
}));

export default function ViewSubCategory({ viewableRow, open, setOpen }) {
    const classes = getSx(true);
    const closeModalHandler = () => {
        setOpen(false)
    }
    return (
        <CustomDialog
            open={open}
            keepMounted
            onClose={() => setOpen(false)}
            TransitionComponent={Transition}
            sx={{ "& .MuiPaper-root": { maxWidth: "400px", paddingLeft: 0, paddingRight: 0 } }}
        >
            <DialogContent sx={{ padding: "8px 20px" }}>
                <Box sx={{ ...classes.subTitleContainer, gap: "1rem" }}>
                    <Box>
                        <Typography
                            sx={{
                                fontSize: "20px",
                                minWidth: "300px",
                                maxWidth: "400px",
                                textAlign: "center"
                            }}
                        >
                            Sub Categories
                        </Typography>
                    </Box>

                    <Box sx={{ display: "flex", rowGap: 1, flexWrap: "wrap", paddingX: "25px" }}>
                        {viewableRow?.subTitle?.map((item, index) =>
                            <Box sx={{ display: "flex", borderRadius: "7px", padding: "7px", fontSize: "16px", backgroundColor: "#0832DE", color: "white", marginRight: "5px" }}>
                                {item}
                            </Box>
                        )}
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions
                disableSpacing={false}
                sx={{ ...classes.buttonWrapper, justifyContent: "center" }}
            >

                <Button
                    style={{ ...classes.button, width: "100px", borderRadius: "12px" }}
                    label="Close"
                    onClick={closeModalHandler}
                />
            </DialogActions>

        </CustomDialog>
    );
}
